import React from 'react'
import { useTranslation } from 'react-i18next'
import { AmenitiesData } from '@popety-io/types'
import { AmenityCard } from './AmenityCard'
import { AmenitiesCategoryGrid } from './Amenities.styles'

export interface AmenitiesListProps {
  data?: AmenitiesData
  className?: string
  onPOIClick?: (poi: any) => void
}

/**
 * AmenitiesList component displays a list of amenity categories with their POIs.
 * Each category is rendered as an expandable card in a 2-column grid.
 *
 * @param data - Amenities data containing category scores and POIs
 * @param className - Optional CSS class name
 */
export const AmenitiesList: React.FC<AmenitiesListProps> = ({
  data,
  className,
  onPOIClick,
}) => {
  const { t } = useTranslation('amenities')

  // Add null checks to prevent errors
  if (!data || !data.category_scores || !Array.isArray(data.category_scores)) {
    return (
      <div className={className}>
        <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
          {t('noData')}
        </div>
      </div>
    )
  }

  return (
    <AmenitiesCategoryGrid className={className}>
      {data.category_scores.map((categoryScore) => (
        <AmenityCard
          key={categoryScore.category}
          categoryScore={categoryScore}
          onPOIClick={onPOIClick}
        />
      ))}
    </AmenitiesCategoryGrid>
  )
}

export default AmenitiesList
